module.exports = __webpack_public_path__ + "static/newmugmain-63b06fa41a5e66232792226a96c955eb.png";